import { useTrackMutation } from '@mote/api'

export type ListeningContext = 'landing-page' | 'embed' | 'extension'

export type UseMoteTrackMutation = (
  event: string,
  payload?: object
) => Promise<void>

export function useMoteTrackMutate(
  listeningContext: ListeningContext,
  authorAssetId: string,
  authorUserId: string
): UseMoteTrackMutation {
  const trackMutation = useTrackMutation()

  function getTrackedData(): Pick<Location, 'href' | 'hostname' | 'pathname'> {
    try {
      return {
        href: window.parent.location.href,
        hostname: window.parent.location.hostname,
        pathname: window.parent.location.hostname
      }
    } catch {
      return {
        href: window.location.href,
        hostname: window.location.hostname,
        pathname: window.location.hostname
      }
    }
  }

  return async (event: string, payload: object = {}) => {
    let embedPayload: object | null = null
    if (listeningContext === 'embed') {
      const location = getTrackedData()
      embedPayload = {
        pageContext: location.href,
        applicationDomain: location.hostname,
        applicationDomainPathPrefix: `${location.hostname}/${
          location.pathname.replace('/', '')?.split('/')?.[0]
        }`
      }
    }

    await trackMutation.mutate!({
      variables: {
        event,
        ...payload,
        ...embedPayload,
        listeningContext,
        authorAssetId,
        authorUserId
      }
    })
  }
}
